export default "__VITE_ASSET__DUnxp0T0__"